// based on rc-rate 2.5.0
import Rate from './src/';
export default Rate;